import { t } from "i18next";
import * as z from "zod";

import {
  WALLET_KYC_LEVELS,
  WALLET_OWNER_TYPES,
  WALLET_STATUSES,
} from "@/features/shared/api/enums";

/**
 * Schéma du formulaire de création d'un portefeuille (`POST /Wallets/add`) —
 * étape 3 du parcours d'inscription : le portefeuille naît en PENDING_KYC /
 * TIER0.
 *
 * Factory (règle projet) : créé via `createWalletSchema()` et mémoïsé au
 * niveau composant sur la langue courante — jamais d'instance exportée.
 * Les valeurs d'énumérations viennent de l'annexe A (features/shared).
 */
export const createWalletSchema = () =>
  z.object({
    ownerType: z.enum(WALLET_OWNER_TYPES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    ownerPartyId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    keycloakUserId: z.string().trim().or(z.literal("")),
    currency: z
      .string()
      .trim()
      .regex(/^[A-Z]{3}$/, { message: t("invalidFieldError") }),
    kycLevel: z.enum(WALLET_KYC_LEVELS, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    status: z.enum(WALLET_STATUSES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
  });

export type WalletFormValues = z.infer<ReturnType<typeof createWalletSchema>>;
